import { FC } from 'react'

import { HStack, IconButton, IconName } from '@revolut-internal/ui-kit'
import { TableRowHeight } from '@revolut-internal/ui-kit-table'

type TableViewPickerProps = {
  value: TableRowHeight
  onClick: (value: TableRowHeight) => void
}

const SIZE_VARIANTS: { size: TableRowHeight; icon: IconName }[] = [
  {
    size: TableRowHeight.LARGE,
    icon: 'ViewListLarge',
  },
  {
    size: TableRowHeight.MEDIUM,
    icon: 'ViewListMedium',
  },
  {
    size: TableRowHeight.SMALL,
    icon: 'ViewListSmall',
  },
]

export const TableViewPicker: FC<TableViewPickerProps> = ({ value, onClick }) => (
  <HStack space="s-4">
    {SIZE_VARIANTS.map(({ size, icon }) => (
      <IconButton
        key={size}
        useIcon={icon}
        tapArea={24}
        color={value === size ? 'grey-tone-50' : 'grey-tone-20'}
        iconOnly
        onClick={() => onClick(size)}
      >
        Select {size} size
      </IconButton>
    ))}
  </HStack>
)
